import { Separator } from '@/components/separator/separator'

import { EXTERNAL_URLS } from '@/lib/constants/url'
import { cn } from '@/lib/utils'

export const Footer = () => {
  return (
    <div className={cn('w-full', 'h-[90px]', 'px-5 py-9', 'bg-elevated')}>
      <div className={cn('flex items-center', 'max-w-[1144px]', 'mx-auto')}>
        <p className={cn('text-[16px] font-normal leading-[16px] text-black')}>Powered by</p>
        <img src={EXTERNAL_URLS.lawfullyProFullLogo} alt="Lawfully Pro logo" className={cn('h-[20px]', 'ml-3')} />
        <Separator orientation="vertical" className={cn('mx-4', 'h-[18px]', 'bg-[#d9d9d9]')} />
        <p className={cn('text-[14px] font-normal leading-[16px] text-black')}>
          <a href={EXTERNAL_URLS.lawfullyProLandingPage} hrefLang="en" target="_blank" rel="noreferrer">
            Learn more about Lawfully Pro
          </a>
        </p>
      </div>
    </div>
  )
}
